import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApproveRefillRequestT, ResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { refillAction } from '../api/refillAction.js';
import { rxKeys } from './keys.js';

export interface ApproveRefillVariables {
  refillId: number;
  data: ApproveRefillRequestT;
  pendingParams?: {
    basic?: Parameters<typeof rxKeys.pendingRefills>[0];
    detailed?: Parameters<typeof rxKeys.pendingRefillsDetailed>[0];
  };
}

export function useApproveRefillMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'refills', 'approve'],
    mutationFn: async ({ refillId, data }: ApproveRefillVariables): Promise<ResponseT> => {
      return await refillAction.approve(refillId, data);
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: rxKeys.pendingRefills(variables.pendingParams?.basic),
        }),
        queryClient.invalidateQueries({
          queryKey: rxKeys.pendingRefillsDetailed(variables.pendingParams?.detailed),
        }),
      ]);
    },
  });
}
